import { useTheme } from "@emotion/react";
import { useAtom, useAtomValue } from "jotai";
import React from "react";
import { baseAtom, selectEditingInterview } from "../../../stores/jotai/base";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  MoreVert,
} from "@mui/icons-material";
import DiscoveryCompactMenuItem from "../discovery-compact-menu-item";
import IwButton from "../../app/IwButton";
import { artifactAtom } from "../../../stores/jotai/artifacts/artifacts";

const InterviewSelectionAndOperate = (props) => {
  const {
    allInterview,
    openInterviewListDrawer,
    setOpenInterviewListDrawer,
    setAnchorEl,
  } = props;

  const theme = useTheme();
  const [base, setBase] = useAtom(baseAtom);

  const artifacts = useAtomValue(artifactAtom);

  const selectedInterviewDetails = allInterview?.find(
    (interview) => interview?.interviewID === base.selectedInterview
  );

  const selectedInterviewID = base.selectedInterview;
  const notes = artifacts?.note?.[selectedInterviewID];
  const transcript = artifacts?.transcript?.[selectedInterviewID];
  const video = artifacts?.video?.[selectedInterviewID];
  const media = artifacts?.media?.[selectedInterviewID];

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenInterviewListDrawer((prev) => !prev);
  };
  return (
    <>
      <Box>
        <Stack
          direction="row"
          sx={{ gap:1, alignItems: "center", flexGrow: "1" }}
        >
          <Button
            sx={{
              color: theme.custom.mainIconColor,
              border: `1px solid ${theme.custom.borderGrey}`,
              // borderColor: theme.custom.borderGrey,
              background: "white",
              justifyContent: "flex-start",
              textAlign: "left",
              // width: "73%",
              padding: "7px 7px 6px 7px",
              pr: 2,
              minWidth:'350px',
              // mb: "12px",
              "& .MuiButton-startIcon": {
                marginRight: "8px",
              },
              ":hover": {
                color: theme.custom.mainButtonHighlight,
                border: `1px solid ${theme.custom.mainButtonHighlight}`,
                background: "white",
              },
              height: "100%",
              width:"350px",
            }}
            onClick={handleToggle}
            endIcon={
              openInterviewListDrawer ? (
                <KeyboardArrowUp />
              ) : (
                <KeyboardArrowDown />
              )
            }
          >
            <Typography
              sx={{
                width: "350px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {
                selectedInterviewDetails ? selectedInterviewDetails?.interviewee :"Select Interview"
              }
            </Typography>
          </Button>

          <DiscoveryCompactMenuItem
            edit={() => {
              //@ts-ignore
              selectEditingInterview(setBase, selectedInterviewDetails);
            }}
            interviewee={selectedInterviewDetails?.interviewee}
            interviewID={selectedInterviewDetails?.interviewID}
            artifacts={{ notes, transcript, video, media }}
            style={{ ":hover": { textDecoration: "underline" } }}
            renderButton={(renderProps) => {
              const { onClick, onTouchStart, ...otherRenderProps } =
                renderProps;

              return (
                <IwButton
                  onClick={(event) => {
                    event.stopPropagation();
                    onClick(event);
                  }}
                  onTouchStart={(event) => {
                    event.stopPropagation();
                    onTouchStart(event);
                  }}
                  variant="outlined"
                  disabled={selectedInterviewDetails===undefined}
                  startIcon={<MoreVert sx={{ transform: "rotate(90deg)" }} />}
                  sx={{
                    padding: "18px 0",
                    maxWidth: "10%",
                    minWidth: "45px",
                    ".MuiCircularProgress-svg": {
                      color: theme.custom.white,
                    },
                    "& .MuiButton-startIcon": {
                      marginRight: "0px",
                    },
                    border: `1px solid ${theme.custom.borderGrey}`,
                    background: "white",
                    color: theme.custom.grayLabelText,
                    ":hover": {
                      color: theme.custom.mainButtonHighlight,
                      border: `1px solid ${theme.custom.mainButtonHighlight}`,
                      background: "white",
                    },
                  }}
                />
              );
            }}
            menuSide="right"
            menuSx={{
              margin: "12px 0 0",
            }}
          />
        </Stack>
      </Box>
    </>
  );
};

export default InterviewSelectionAndOperate;
